import { render, staticRenderFns } from "./imgDraw.vue?vue&type=template&id=6b34dda0&scoped=true&"
import script from "./imgDraw.vue?vue&type=script&lang=js&"
export * from "./imgDraw.vue?vue&type=script&lang=js&"
import style0 from "./imgDraw.vue?vue&type=style&index=0&id=6b34dda0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b34dda0",
  null
  
)

export default component.exports